import SvgIcon from "./IconScan.svg?react";
const IconScan = SvgIcon;
export default IconScan;
